import type { UiPalette } from '@theme/uiPalette.types'

/**
 * Accent xanh hệ AZL — đồng bộ banhang-frontend (`uiPalette` / `#0070f4`).
 */
export const PALETTE_BLUE: UiPalette = {
  primary: {
    main: '#0070f4',
    dark: '#0055c0',
    light: '#3d94f7',
    surface: '#e8f2fe',
    surfaceBorder: '#c5daf5',
    hover: 'rgba(0, 112, 244, 0.08)',
  },
  neutral: {
    background: '#e6eaef',
    backgroundDeep: '#dde2e8',
    border: 'rgba(51, 51, 51, 0.08)',
    borderMedium: 'rgba(51, 51, 51, 0.14)',
    outline: '#d9d9d9',
    text: '#333333',
    textMuted: '#666666',
    textSubtle: '#999999',
  },
  shell: {
    headerSolid: '#0070f4',
    headerBorder: 'rgba(255, 255, 255, 0.14)',
    headerShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
    sidebarBg: '#ffffff',
    sidebarBorder: '#e2e8f0',
    sidebarItem: '#1e293b',
    sidebarIcon: '#64748b',
    sidebarHoverBg: '#f1f5f9',
    sidebarActiveBg: '#eff6ff',
    sidebarActiveBgHover: '#dbeafe',
    sidebarActiveText: '#1d4ed8',
    sidebarActiveIcon: '#2563eb',
    sidebarActiveBar: '#2563eb',
    sidebarSectionBg: '#f1f5f9',
    sidebarSectionText: '#1e40af',
    sidebarSectionBar: '#64748b',
    sidebarOpenParentBg: '#fafafa',
    sidebarOpenParentBar: '#e2e8f0',
    popoverBg: '#ffffff',
    popoverBorder: '#e2e8f0',
    popoverShadow: '0 12px 40px rgba(15, 23, 42, 0.1)',
    navRail: 'rgba(148, 163, 184, 0.35)',
  },
  table: {
    headBg: '#e5f1fd',
    headBorder: '#d6e4f2',
    headText: '#333333',
    cellBorder: '#eeeeee',
    rowHoverBg: '#f5f8fb',
    rowSelectedBg: '#dbeafe',
    rowSelectedHoverBg: '#bfdbfe',
    paginationBg: '#f7f7f7',
    wrapperBorder: '#eaedf1',
    nestedHeadBg: '#eff6ff',
    nestedHeadText: '#1e40af',
    nestedHeadBorder: '#bfdbfe',
    level2HeadBg: '#eff6ff',
    level2HeadText: '#1e40af',
    level2HeadBorder: '#bfdbfe',
    level3HeadBg: '#fafbfc',
    level3HeadText: '#666666',
    level3HeadBorder: '#e8ecf2',
  },
  secondary: {
    main: '#0d9488',
    dark: '#0f766e',
    light: '#14b8a6',
  },
  status: {
    error: '#dc2626',
    warning: '#d97706',
    success: '#15803d',
    info: '#0070f4',
  },
}
